import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";

export enum AvengersTheme {
  LIGHT = "light",
  DARK = "dark",
}

export const themeSliceName = "theme";
export type ThemeState = AvengersTheme;

const persistedTheme = localStorage.getItem(themeSliceName);
const persistedState = persistedTheme ? JSON.parse(persistedTheme) : null;
const initialState: ThemeState = persistedState ?? AvengersTheme.DARK;

const themeSlice = createSlice({
  name: themeSliceName,
  initialState,
  reducers: {
    setTheme(_, action: PayloadAction<ThemeState>) {
      return action.payload;
    },
  },
});

export interface ThemeRootState {
  [themeSliceName]: ThemeState;
}

export const selectTheme = (state: ThemeRootState) => state[themeSliceName];
export const setTheme = (theme: ThemeState) => (dispatch: Dispatch) => {
  applyThemeClassNameToElement(document.documentElement, theme);
  localStorage.setItem(themeSliceName, JSON.stringify(theme));
  dispatch(themeSlice.actions.setTheme(theme));
};

// convenience function for AGGrid Theme
export const selectAgGridTheme = (state: ThemeRootState) => {
  return state[themeSliceName] === AvengersTheme.DARK ? "ag-theme-alpine-dark" : "ag-theme-alpine";
};

export const { setTheme: setThemeAction } = themeSlice.actions;
export const themeSliceReducer = themeSlice.reducer;

// apply the initial theme to the document body
applyThemeClassNameToElement(document.documentElement, initialState);

function applyThemeClassNameToElement(el: HTMLElement, theme: AvengersTheme) {
  el.classList.forEach((className) => {
    if (className.startsWith("avengers-theme-")) {
      el.classList.remove(className);
    }
  });

  el.classList.add(`avengers-theme-${theme}`);
}
